import { useMutation } from 'react-query';
import axios from "axios";
import { useClientId } from "../context/context.js";

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useLogin() {
  const clientId = useClientId();

  const authenticate = async ({ token }) => {

    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const { data } = await axios.get(
      `${apiBaseUrl}/clients/${clientId}/authenticate`,
      {
        headers,
      }
    );

    return data;
  };

  const loginRequest = async ({ password }) => {
    const { data } = await axios.post(`${apiBaseUrl}/clients/${clientId}/login`, { password });
    return data;
  };

  return {
    authenticate,
    loginRequest,
  };
}
